import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";

const MembershipRetentionRateChartView = () => {
    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [iframeUrlApi] = useIframeUrlMutation();

    const fetchIframeUrl = async () => {
        setLoading(true);
        setError("");

        try {
            const requestPayload = {
                QuestionId: 67,
                params: {},
                expMinutes: 0,
                bordered: false,
                titled: true,
            };

            const response = await iframeUrlApi(requestPayload).unwrap();
            setIframeUrl(response.iframeUrl);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch iframe URL");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIframeUrl();
    }, []);

    const handleReload = () => {
        fetchIframeUrl();
    };

    return (
        <div style={{ padding: "20px" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <button
                    onClick={handleReload}
                    className="btn success-btn reload-btn"
                    disabled={loading}
                >
                    {loading ? "Loading..." : "Reload Report"}
                </button>
            </div>

            {loading && <p>Loading report...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            {iframeUrl && (
                <div
                    className="iframe-main-card"
                    style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}
                >
                    <iframe
                        src={iframeUrl}
                        style={{ flex: 1, minWidth: 0, border: 0 }}
                        height="600"
                        title="Metabase Report"
                    />
                </div>
            )}
        </div>
    );
};

export default MembershipRetentionRateChartView;
